// extracted by mini-css-extract-plugin
export default {"root":"portfolio_root__Asv0K","header":"portfolio_header__6vSMP","icon":"portfolio_icon__EwNKN","nullStateIcon":"portfolio_nullStateIcon__V8GQc"};